import { getResources } from "@/business/deliveries/application/getResources";
import { Resource } from "@/business/deliveries/domain/deliveries";
import { ref, Ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { SelectOption } from "@/business/shared/commons/selectOption";
import { getClientsLikeSelectOption } from "@/business/clients/application/getClientsLikeSelectOption";
import { getClientsByIdCompany } from "@/business/clients/application/getClientsByIdCompany";
import { ClientList } from "@/business/clients/domain/clients";
import { createDelivery } from "@/business/deliveries/application/createDelivery";

export function createEditDeliveryUse() {
    const router = useRouter();
    const resources: Ref<Resource[]> = ref([]);
    const clientList: Ref<SelectOption[]> = ref([]);
    const clients: Ref<ClientList[]> = ref([]);

    onMounted(async () => {
        await getResourcesFromApi();
        clients.value = await getClientsByIdCompany.execute();
        clientList.value = await getClientsLikeSelectOption.execute(clients.value);
    });

    async function backDeliveriesOption() {
        await router.push("/administrator/deliveries");
    }

    async function getResourcesFromApi(): Promise<void> {
        resources.value = await getResources.execute();
    }

    async function createDeliveryOperation(
        client: string,
        name: string,
        message: string,
        approvedFiles: string | null,
        rejectedFiles: string | null,
        deliveryDate: string
    ) {
        await createDelivery.execute(
            client,
            name,
            message,
            null,
            null,
            deliveryDate
        );
    }

    return {
        backDeliveriesOption,
        resources,
        clients,
        clientList,
        createDeliveryOperation,
    };
}
